module.exports = __webpack_public_path__ + "static/img/icon-04.29ba7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/value/icon-04.png
// module id = bY88
// module chunks = 1